/**
 * @flow
 * @relayHash 76ecb8a21d9b890fe1349dd864c1aa94
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type SportografNavigationBar_viewer$ref = any;
export type SportografNavigationBarRefetchQueryVariables = {||};
export type SportografNavigationBarRefetchQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: SportografNavigationBar_viewer$ref
  |}
|};
export type SportografNavigationBarRefetchQuery = {|
  variables: SportografNavigationBarRefetchQueryVariables,
  response: SportografNavigationBarRefetchQueryResponse,
|};
*/


/*
query SportografNavigationBarRefetchQuery {
  viewer {
    ...SportografNavigationBar_viewer
    id
  }
}

fragment SportografNavigationBar_viewer on Viewer {
  cart {
    lineItems {
      id
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SportografNavigationBarRefetchQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "SportografNavigationBar_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SportografNavigationBarRefetchQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "cart",
            "storageKey": null,
            "args": null,
            "concreteType": "Cart",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "lineItems",
                "storageKey": null,
                "args": null,
                "concreteType": "LineItem",
                "plural": true,
                "selections": [
                  (v0/*: any*/)
                ]
              },
              (v0/*: any*/)
            ]
          },
          (v0/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "SportografNavigationBarRefetchQuery",
    "id": null,
    "text": "query SportografNavigationBarRefetchQuery {\n  viewer {\n    ...SportografNavigationBar_viewer\n    id\n  }\n}\n\nfragment SportografNavigationBar_viewer on Viewer {\n  cart {\n    lineItems {\n      id\n    }\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '47d7c7adf5f39500a7e7c4775272646e';

module.exports = node;
